import { requestTypes } from '../constants'

export const initialValues = {
  ClientType: 3,
  action: requestTypes.add,
  Open_Day: '',

  // organization information default values (checked)
  FullName: '',
  FullName_ALT: '',
  LegalStatusID: 3,
  ORG_IndustryID: 7,
  ORG_IndustrySubID: 15,
  BusinessTypeID: '',
  ORG_OwnerStatusID: 1,
  ORG_Owner: '',
  ORG_IndustrySubDetailID: 1,
  ORG_FinInstID: 1,
  ORG_GovRelID: 1,
  ORG_TransparencyID: 1,
  IND_Resident: 1,
  RiskLevelID: 1,
  SDAEnabled: 1,

  // registration details default values (checked)
  ORG_RegDate: '',
  CardNumber: '',
  CardNumberAlt: '',

  // address information default values (checked)
  Address: '',
  Address_ALT: '',
  CityID: 1,
  AddressBus: '',
  AddressBus_ALT: '',
  CityBusID: 1,
  DistrictBusID: 1,
  ZoneBusID: 1,

  // contact information default values (checked)
  Phone: '',
  ORG_Phone: '',
  CellPhone: '',
  ORG_Fax: '',
  Email: '',
  ORG_Web: '',
  Email1: '',
  AMLStatusID: 1,
  AMLIndustryID: 1,
  AMLSuspiciousID: 1,
  EmailPrefID: 1,
  KYCValidityID: 1,
  MCLEnabled: 1,
  AutoCoverPrefID: 1,
  StatusLevelID: 1,
  NodeID: 1,
  SMSPrefID: 1,
  CellPhoneValidateCode: '',

  // additional fields default values (checked)
  CField1: '',
  CField2: '',
  CField3: '',
  CField4: '',
  CountryID: '',
  CountryBusID: '',
}

export const SECTIONS = 4
